// Matches the 'en' grouping used by gung-standard's GungTransformCurrencyPipe.
const numberFormatter = new Intl.NumberFormat('en', { maximumFractionDigits: 2 });

// Above this, exact values stop being readable at a glance — round to 3 significant digits.
const ROUNDING_THRESHOLD = 10000;

export function isNumericColumn(rows: Record<string, unknown>[], key: string): boolean {
  const values = rows.map(row => row[key]).filter(v => v !== null && v !== undefined);
  return values.length > 0 && values.every(v => typeof v === 'number' && Number.isFinite(v));
}

export function formatCellValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return String(value);
  }

  const abs = Math.abs(value);
  if (abs >= ROUNDING_THRESHOLD) {
    const magnitude = Math.pow(10, Math.floor(Math.log10(abs)) - 2);
    return numberFormatter.format(Math.round(value / magnitude) * magnitude);
  }
  return numberFormatter.format(value);
}
